export const phonePattern = (_, value, callback) => {
  const phoneRegex = /^(1[3-9]\d{9}|0\d{2,3}-\d{7,8})$/;

  if (!phoneRegex.test(value) && value) {
    callback("手机号码格式错误");
  }

  callback();
};

export function debouncePromise<T extends (...args: any[]) => Promise<any>>(
  fn: T,
  wait: number = 300
): (...args: Parameters<T>) => ReturnType<T> {
  let timer: ReturnType<typeof setTimeout>;

  return (...args: Parameters<T>) => {
    return new Promise((resolve, reject) => {
      clearTimeout(timer);

      timer = setTimeout(() => {
        fn(...args)
          .then(resolve)
          .catch(reject);
      }, wait);
    }) as ReturnType<T>;
  };
}

export const getDefaultTitle = (
  isEdit: boolean,
  title: string | React.ReactNode
) => {
  if (title) return title;

  return isEdit ? "编辑公司" : "新增公司";
};
